import { createAsyncThunk } from '@reduxjs/toolkit';
import { ModeratorEntity, ModeratorResponse } from '@interpals/api-web';

import api from 'api';

export const MODERATOR_FETCH_LIMIT = 25;

export const getModerators = createAsyncThunk<ModeratorResponse, { offset: number }>(
    'get/moderators',
    async ({ offset }) => {
        return api.getModerators({ limit: MODERATOR_FETCH_LIMIT, offset });
    },
);

export const getModerator = createAsyncThunk<ModeratorEntity, { id: string }>('get/moderator', async ({ id }) => {
    return api.getModerator({ id });
});
